import PortfolioDetail2Container from "../../../../components/pages/portfolio/detail/PortfolioDetail2";

const PortfolioDetail2 = () => {
  return <PortfolioDetail2Container />;
};

export default PortfolioDetail2;
